<template>
  <footer class="footer">
    <div class="b-footer">
      <div class="columns">
        <div class="column">
          <strong>Unsere Partner</strong>
          <ul class="b-partners">
            <li><a href="https://denic.de"><img src="../assets/partners/denic.png"></a></li>
            <li><a href="https://ripe.net"><img src="../assets/partners/ripe.png"></a></li>
            <li><a href="https://eco.de"><img src="../assets/partners/eco.png"></a></li>
            <li><a href="https://www.cyberforum.de/"><img class="cyberforum"
                                                          src="../assets/partners/cyberforum.png"></a></li>
            <li><a href="https://ihk-biz.de"><img src="../assets/partners/ihk.png"></a></li>
            <li><a href="https://www.karlsruhe.dhbw.de"><img src="../assets/partners/dhbw.png"></a></li>
          </ul>
        </div>
        <div class="b-legacy column is-narrow">
          <strong>Legacy Services</strong>
          <ul>
            <li><a href="https://nagios.bringe.net/nagios3/">Nagios</a></li>
            <li><a href="https://monitor2.bringe.net/cacti/">Cacti</a></li>
            <li><a href="http://service.bringe.net/ipaccounting/">IP Accounting</a></li>
            <li><a href="https://reboot.bringe.net/">Server Reboot</a></li>
            <li><a href="https://mail.bringe.net/SOGo/">Webmail</a></li>
          </ul>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <p>2025 © bringe Informationstechnik GmbH</p>
        </div>
        <div class="b-impressum column">
          <b-foot-datenschutz></b-foot-datenschutz>
          |
          <b-foot-impressum></b-foot-impressum>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import BFootImpressum from '@/views/BFootImpressum.vue';
import BFootDatenschutz from '@/views/BFootDatenschutz.vue';

export default {
  name: 'BFoot',
  components: {
    BFootImpressum,
    BFootDatenschutz,
  },
}
</script>

<style lang="scss" scoped>
  .b-footer {
    margin-left: auto;
    margin-right: auto;
    font-size: .9em;
    max-width: 1200px;
    .b-impressum,
    .b-legacy {
      text-align: right;
    }
  }

  .b-partners {
    margin-left: -.5rem !important;
    li {
      display: inline;
      height: 100%;
      line-height: 100%;
    }
    img {
      padding: .5rem;
      filter: grayscale(100%);
      width: 7rem !important;
      vertical-align: middle;
    }
    .cyberforum {
      filter: invert(100%);
    }
  }
</style>
